const MAX_RECURSION = 100;
class UpdateScheduler {
  constructor(performUpdate) {
    this._pending = false;
    this._resolve = null;
    this._recursionCount = 0;
    this._performUpdate = performUpdate;
    this._promise = Promise.resolve(true);
  }
  schedule() {
    if (this._pending) return;
    this._pending = true;
    this._promise = new Promise((resolve) => {
      this._resolve = resolve;
      queueMicrotask(() => this._flush(resolve));
    });
  }
  _flush(resolve) {
    this._pending = false;
    this._recursionCount++;
    if (this._recursionCount > MAX_RECURSION) {
      this._recursionCount = 0;
      resolve(false);
      return;
    }
    const success = this._performUpdate();
    if (this._pending) {
      this._promise.then(resolve);
    } else {
      this._recursionCount = 0;
      resolve(success);
    }
  }
  get updateComplete() {
    return this._promise;
  }
}
export {
  UpdateScheduler
};
//# sourceMappingURL=update-cycle.js.map
